import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/atoms/button';
import { RoutePermissionDenied } from '@/components/molecules';
import { ContactFormPanel } from '@/components/organisms/contacts/ContactFormPanel';
import { useContact } from '@/hooks/contacts/useContact';
import { useRoutePermission } from '@/hooks/navigation/useRoutePermission';

export const Route = createFileRoute('/_dashboard/dashboard/contacts/$contactId/edit')({
  component: EditContactPage,
});

function EditContactPage() {
  const { contactId } = Route.useParams();
  const navigate = useNavigate();
  const canEditContacts = useRoutePermission('contacts:edit');
  const query = useContact(contactId, { enabled: canEditContacts });

  function navigateToDetail() {
    navigate({
      to: '/dashboard/contacts/$contactId',
      params: { contactId },
    });
  }

  if (!canEditContacts) {
    return <RoutePermissionDenied message="You do not have permission to edit contacts." />;
  }

  if (query.isError && query.error?.status === 404) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4 text-center">
        <AlertCircle className="h-10 w-10 text-muted-foreground" />
        <div>
          <p className="font-semibold">Contact not found</p>
          <p className="text-sm text-muted-foreground">The contact may have been deleted.</p>
        </div>
        <Button onClick={() => navigate({ to: '/dashboard/contacts' })}>Back to Contacts</Button>
      </div>
    );
  }

  return (
    <ContactFormPanel
      mode="edit"
      contact={query.data}
      isLoading={query.isLoading}
      onCancel={navigateToDetail}
      onSaved={navigateToDetail}
    />
  );
}
